// services/organizationService.js

import API from "../api/api";

export const organizationService = {

  getFeatures: async () => {
    const response = await API.get('/get_features');
    return response.data.data || [];
  },
  getOrganizationFeatures: async () => {
    const response = await API.get('/get_organization_features');
    return response.data.data || [];
  },
  updateOrganizationFeatures: async (data) => {
    const response = await API.post('/update_organization_features', data);
    return response.data.data;
  },
};